export var ERecordingStatus;
(function (ERecordingStatus) {
    ERecordingStatus["INACTIVE"] = "INACTIVE";
    ERecordingStatus["RECORDING"] = "RECORDING";
    ERecordingStatus["PAUSED"] = "PAUSED";
})(ERecordingStatus || (ERecordingStatus = {}));
